module.exports = __webpack_public_path__ + "static/media/blank-image.ab953430.jpeg";